import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_BLOCK_WITHOUT_COMMUNITY } from "./apiRoutes";

interface GetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}
const getPropertyBlockByCommunityId = async (communityId: string) => await axiosAuth.get(`${PROPERTY_BLOCK_WITHOUT_COMMUNITY}/community/${communityId}`);

const useGetPropertyBlockByCommunityId = ({
  communityId,
  queryParams
}: GetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-block", communityId],
    queryFn: () => getPropertyBlockByCommunityId(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetPropertyBlockByCommunityId;
